import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import { PurchaseOrderPdfSkuLine } from '../../PurchaseOrderPdf.types';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    borderBottomWidth: 1,
    borderBottomColor: '#4CAF50',
  },
  cell: {
    padding: 5,
    fontSize: 8,
    textAlign: 'center',
    borderRightWidth: 1,
    borderRightColor: '#4CAF50',
  },
  lastCell: {
    borderRightWidth: 0,
    textAlign: 'left',
  },
});

type Props = {
  line: PurchaseOrderPdfSkuLine;
  isOdd?: boolean;
};

const formatMoney = (value: number) =>
  value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

const SkuTableRow = ({ line, isOdd = false }: Props) => (
  <View
    style={[styles.row, { backgroundColor: isOdd ? '#ffffff' : '#f6fffa' }]}>
    <Text style={[styles.cell, { width: 80 }]}>{line.artNumber}</Text>
    <Text style={[styles.cell, { width: 100 }]}>
      {line.manufacturerSkuId} {line.manufacturerDescription || '-'}
    </Text>
    <Text style={[styles.cell, { width: 56 }]}>{line.skuName}</Text>
    <Text style={[styles.cell, { width: 44 }]}>{line.boxQty}</Text>
    <Text style={[styles.cell, { width: 44 }]}>
      {line.manufacturerItemsInBox || '-'}
    </Text>
    <Text style={[styles.cell, { width: 48 }]}>{line.totalUnits}</Text>
    <Text style={[styles.cell, { width: 52 }]}>
      ${formatMoney(line.costPerBox)}
    </Text>
    <Text style={[styles.cell, { width: 52 }]}>
      ${line.costPerUnit.toFixed(4)}
    </Text>
    <Text style={[styles.cell, { width: 52 }]}>
      ${formatMoney(line.totalCost)}
    </Text>
  </View>
);

export default SkuTableRow;
